"use strict";

/** 
* Коллекция реквизитов.
*
* @class WebAccess.components.wrappers.form.RequisiteCollection
* @extends WebAccess.Collection
* @since 5.2.0.1900
*/

(function (global) {

  var RequisiteCollection = global.Collection.extend({
    className: 'RequisiteCollection',
    
    /**
    * Значение всех реквизитов в виде словоря.
    *
    * @method WebAccess.components.wrappers.form.RequisiteCollection.toDictionary
    * @return {Object} Значение всех реквизитов.
    * @since 5.2.0.1900
    */
    toDictionary: function () {
      var resultDict = {};
      var reqs = this.toArray();
      for (var reqI = 0; reqI < reqs.length; reqI++) {
        resultDict[reqs[reqI].name] = reqs[reqI].getValue();
      }
      return resultDict;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
 
  });

  global.components.wrappers.form.RequisiteCollection = RequisiteCollection;
})(window.WebAccess);